export default {
  // ========== Selector de archivos ==========
  selectFileOrDrag: 'Seleccione un archivo o arrástrelo aquí...',
  browse: 'Buscar',

  // ========== Validaciones de archivo ==========
  fileSizeExceeded: 'El archivo no puede superar {maxSize} de tamaño.',

  // ========== Estados de carga ==========
  saving: 'Guardando...',
  uploadingFile: 'Subiendo archivo...',
  pleaseWaitUpload: 'Por favor, espera mientras se sube el archivo.',

  // ========== Mensajes de éxito ==========
  fileSaved: 'Archivo guardado.',

  // ========== Mensajes de error ==========
  problemUploadingFile: 'Hubo un problema al subir el archivo.',
}
